import { CategoryReport, ReportDocument, ReportDocumentTemplate } from '../api/app-types/report-document.app';

export const mockCategoryReport: CategoryReport[] = [
	{
		description: 'Kategorie Bericht 1',
		id: 1,
	},
	{
		description: 'Kategorie Bericht 2',
		id: 2,
	},
];

export const mockReportDocumentTemplates: ReportDocumentTemplate[] = [
	{
		id: 1,
		htmlContent: '<p>Vorlage Inhalt 1</p>',
	},
	{
		id: 2,
		htmlContent: '<p>Vorlage Inhalt 2</p>',
	},
];

export const mockReportDocuments: ReportDocument[] = [
	{
		id: 1,
		htmlContent: '<p>Bericht Inhalt 1</p>',
		isFinal: true,
		isDraft: false,
		canBeSubmitted: false,
		createdAt: new Date('2024-01-15T10:00:00Z'),
		updatedAt: new Date('2024-02-20T12:00:00Z'),
		template: mockReportDocumentTemplates[0],
		categoryReport: mockCategoryReport[1],
	},
	{
		id: 2,
		htmlContent: '<p>Bericht Inhalt 2</p>',
		isFinal: false,
		isDraft: true,
		canBeSubmitted: true,
		createdAt: new Date('2024-03-10T14:30:00Z'),
		template: mockReportDocumentTemplates[1],
		categoryReport: mockCategoryReport[1],
	},
];
